module.exports = __webpack_public_path__ + "static/media/for-students-second@3x.557cfcd7.jpg";